import { render, staticRenderFns } from "./BusinessAdvantageCard.vue?vue&type=template&id=81f2eeac&scoped=true"
import script from "./BusinessAdvantageCard.vue?vue&type=script&lang=js"
export * from "./BusinessAdvantageCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessAdvantageCard.vue?vue&type=style&index=0&id=81f2eeac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f2eeac",
  null
  
)

export default component.exports